import { render, staticRenderFns } from "./gameWheel.vue?vue&type=template&id=a27ebb58&scoped=true&"
import script from "./gameWheel.vue?vue&type=script&lang=js&"
export * from "./gameWheel.vue?vue&type=script&lang=js&"
import style0 from "./gameWheel.vue?vue&type=style&index=0&id=a27ebb58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27ebb58",
  null
  
)

export default component.exports